import { defineStore } from "pinia";
import { api } from 'boot/api-access';

export const useEnumStore = defineStore("enum-store", {
  state: () => ({
    enumsSetMap: () => new Map(),
    enumsMap: () => new Map()
  }),
  actions: {
    async ensureLoadEnum(enumName) {
      try {
        if (!this.enumsMap[enumName]) {
          const { result } = await api.post("/enums/list", {
            EnumName: enumName,
          });
          if (result) {
            const enumValues = new Map();
            result.forEach((r) => {
              enumValues.set(r.value, r.name);
            });
            this.enumsMap[enumName] = result;
            this.enumsSetMap[enumName] = enumValues;
          }
        }
      } catch(e) {
        console.error(e);
      }
      return this.enumsMap;
    },
    getEnumValues(enumName) {
      return this.enumsMap[enumName];
    },
    getEnumValuesSet(enumName) {
      return this.enumsSetMap[enumName];
    },
    getEnumDisplay(enumName, val) {
      const enumValues = this.getEnumValuesSet(enumName);
      if (enumValues && val) {
        return enumValues.get(val);
      }
      return "";
    },
  },
});
